import { MarketPageProps } from './MarketPage.types'
import { PageWrapper } from '@otomoro/components/layout/PageWrapper'
import { Headline } from '@otomoro/components/shared/Headline'
import { FlexibleContent, FlexibleContentProps } from '@otomoro/components/shared/FlexibleContent'

export default function MarketPage({ data }: MarketPageProps) {
	if (!data) {
		return (
			<div className="text-center">
				Please start editing your Market document to see the preview!
			</div>
		)
	}

	return (
		<PageWrapper noPb>
			<Headline
				size="large"
				theme="light"
				border
				headlineText={data.headline}
				subheadline={data.subHeadline}
				healineSize="42px"
			></Headline>
			<FlexibleContent blocks={data.flexibleContent as FlexibleContentProps['blocks']} />
		</PageWrapper>
	)
}
